
import React from "react";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DocumentLinkFieldProps {
  element: FormFieldType;
  documentUrls: string[];
}

export const DocumentLinkField: React.FC<DocumentLinkFieldProps> = ({ element, documentUrls }) => {
  const { t } = useTranslation();
  // Ensure documentUrls is always an array
  const urls = Array.isArray(documentUrls) ? documentUrls : [];

  if (urls.length === 0) {
    return null;
  }
  
  return (
    <FieldWrapper element={element}>
      <div className="space-y-2">
        <p className="text-sm font-medium text-green-600">
          {t('form.fields.documentLinkAvailable')}
        </p>
        
        <ul className="list-disc pl-5 text-sm space-y-1">
          {urls.map((url, index) => (
            <li key={index} className="flex items-center">
              <ExternalLink className="h-4 w-4 mr-2" />
              <a 
                href={url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:underline"
              >
                {t('form.fields.documentLinkItem', { index: index + 1 })}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </FieldWrapper>
  );
};

export default DocumentLinkField;
